// Curated list of funding platforms available to African startups & SMEs.
// SeedTechNG prepares the application for each — flat fee $1,000 per platform,
// 10% off when a client selects 4 or more platforms in one engagement.

export const FUNDERS = [
  // ---------- GRANTS / FOUNDATIONS ----------
  {
    id: "tef",
    name: "Tony Elumelu Foundation",
    category: "Grant",
    focus: "Pan-African entrepreneurs, all sectors",
    ticket: "$5K seed capital + training",
    region: "All Africa",
  },
  {
    id: "mastercard",
    name: "Mastercard Foundation",
    category: "Grant",
    focus: "Youth employment, agriculture, education",
    ticket: "$50K – $5M",
    region: "Sub-Saharan Africa",
  },
  {
    id: "gates",
    name: "Gates Foundation",
    category: "Grant",
    focus: "Health, agriculture, financial inclusion",
    ticket: "$100K – $10M",
    region: "Global / Africa",
  },
  {
    id: "aecf",
    name: "Africa Enterprise Challenge Fund (AECF)",
    category: "Grant",
    focus: "Agribusiness, renewable energy",
    ticket: "$250K – $1.5M",
    region: "23 African countries",
  },
  {
    id: "gif",
    name: "Global Innovation Fund",
    category: "Grant",
    focus: "Social innovation, climate, livelihoods",
    ticket: "$230K – $15M",
    region: "Africa, Asia, LatAm",
  },
  {
    id: "echoinggreen",
    name: "Echoing Green Fellowship",
    category: "Grant",
    focus: "Social entrepreneurs",
    ticket: "$80K + support",
    region: "Global",
  },
  {
    id: "cartier",
    name: "Cartier Women's Initiative",
    category: "Grant",
    focus: "Women-led ventures",
    ticket: "$30K – $100K",
    region: "Global",
  },
  {
    id: "sheloves",
    name: "She Loves Tech",
    category: "Grant",
    focus: "Women in tech",
    ticket: "$10K – $50K + investment",
    region: "Global",
  },
  {
    id: "fate",
    name: "FATE Foundation",
    category: "Grant",
    focus: "Nigerian SMEs",
    ticket: "₦1M – ₦10M",
    region: "Nigeria",
  },

  // ---------- DEVELOPMENT FINANCE (DFI / IGO) ----------
  {
    id: "worldbank",
    name: "World Bank Group",
    category: "DFI",
    focus: "SMEs, infrastructure, climate, digital",
    ticket: "$500K – $50M+",
    region: "All Africa",
  },
  {
    id: "ifc",
    name: "International Finance Corporation (IFC)",
    category: "DFI",
    focus: "Growth-stage businesses",
    ticket: "$1M – $100M+",
    region: "Global / Africa",
  },
  {
    id: "afdb",
    name: "African Development Bank (AfDB)",
    category: "DFI",
    focus: "Infrastructure, agriculture, SMEs",
    ticket: "$1M – $200M",
    region: "All Africa",
  },
  {
    id: "usaid",
    name: "USAID Development Innovation Ventures",
    category: "DFI",
    focus: "Evidence-based development",
    ticket: "$200K – $15M",
    region: "Developing markets",
  },
  {
    id: "fcdo",
    name: "UK FCDO / British International Investment",
    category: "DFI",
    focus: "Climate, women, frontier markets",
    ticket: "$1M – $50M",
    region: "Africa & South Asia",
  },
  {
    id: "fmo",
    name: "FMO (Netherlands)",
    category: "DFI",
    focus: "Energy, financial institutions, agribusiness",
    ticket: "$5M – $40M",
    region: "Emerging markets",
  },
  {
    id: "proparco",
    name: "Proparco (France)",
    category: "DFI",
    focus: "Private sector growth, climate",
    ticket: "$1M – $80M",
    region: "Africa & global",
  },
  {
    id: "deg",
    name: "DEG (Germany)",
    category: "DFI",
    focus: "SMEs, manufacturing",
    ticket: "$1M – $25M",
    region: "Africa & emerging markets",
  },

  // ---------- VC / EQUITY ----------
  {
    id: "futureafrica",
    name: "Future Africa",
    category: "VC",
    focus: "Pre-seed → Seed African tech",
    ticket: "$100K – $1M",
    region: "All Africa",
  },
  {
    id: "tlcom",
    name: "TLcom Capital",
    category: "VC",
    focus: "Series A African tech",
    ticket: "$1M – $10M",
    region: "All Africa",
  },
  {
    id: "partech",
    name: "Partech Africa",
    category: "VC",
    focus: "Seed → Series B African tech",
    ticket: "$500K – $15M",
    region: "All Africa",
  },
  {
    id: "norrsken",
    name: "Norrsken22 Africa Fund",
    category: "VC",
    focus: "Growth-stage African tech",
    ticket: "$2M – $15M",
    region: "Big 4 African ecosystems",
  },
  {
    id: "loftyinc",
    name: "LoftyInc Capital",
    category: "VC",
    focus: "Pre-seed → Series A",
    ticket: "$50K – $2M",
    region: "Pan-African",
  },
  {
    id: "ventures",
    name: "Ventures Platform",
    category: "VC",
    focus: "Pre-seed African tech",
    ticket: "$50K – $500K",
    region: "Nigeria & West Africa",
  },
  {
    id: "microtraction",
    name: "Microtraction",
    category: "VC",
    focus: "Pre-seed African tech",
    ticket: "$25K – $100K",
    region: "Africa",
  },
  {
    id: "africinvest",
    name: "AfricInvest",
    category: "VC",
    focus: "Growth equity, SMEs",
    ticket: "$5M – $30M",
    region: "Pan-African",
  },
  {
    id: "aban",
    name: "Africa Business Angels Network (ABAN)",
    category: "VC",
    focus: "Early-stage angels",
    ticket: "$25K – $250K",
    region: "All Africa",
  },

  // ---------- ACCELERATORS / PROGRAMS ----------
  {
    id: "yc",
    name: "Y Combinator",
    category: "Accelerator",
    focus: "Tech startups, all stages early",
    ticket: "$500K SAFE + program",
    region: "Global",
  },
  {
    id: "techstars",
    name: "Techstars",
    category: "Accelerator",
    focus: "Tech startups, vertical programs",
    ticket: "$120K + program",
    region: "Global",
  },
  {
    id: "catalyst",
    name: "Catalyst Fund",
    category: "Accelerator",
    focus: "Inclusive fintech",
    ticket: "$100K + 6-mo support",
    region: "Africa & emerging",
  },
  {
    id: "endeavor",
    name: "Endeavor",
    category: "Accelerator",
    focus: "Scale-up founders",
    ticket: "Network + capital intros",
    region: "Global",
  },
  {
    id: "foundersfactory",
    name: "Founders Factory Africa",
    category: "Accelerator",
    focus: "Pre-seed → Seed Africa",
    ticket: "$120K + program",
    region: "All Africa",
  },
  {
    id: "alphacode",
    name: "AlphaCode (Rand Merchant)",
    category: "Accelerator",
    focus: "Fintech",
    ticket: "$100K – $1M",
    region: "Southern Africa",
  },
  {
    id: "demoafrica",
    name: "DEMO Africa",
    category: "Accelerator",
    focus: "Tech showcase + investor intros",
    ticket: "Showcase + intros",
    region: "All Africa",
  },
];

export const CATEGORIES = ["All", "Grant", "DFI", "VC", "Accelerator"];

export const PRICE_PER_FUNDER = 1000;
export const DISCOUNT_THRESHOLD = 4; // 4+ funders triggers discount
export const DISCOUNT_PCT = 0.10;
export const MAX_SELECTION = 7;

export function computeQuote(count) {
  const subtotal = count * PRICE_PER_FUNDER;
  const discountApplies = count >= DISCOUNT_THRESHOLD;
  const discountAmount = discountApplies ? subtotal * DISCOUNT_PCT : 0;
  const total = subtotal - discountAmount;
  return { count, subtotal, discountApplies, discountAmount, total };
}
